<template>
	<div>
		<q-dialog v-model="career" persistent transition-show="scale" transition-hide="scale">
			<div class="hris-modal hris-modal-lg" style="max-width: 1140px; width: 100%;">
				<div class="hris-modal-header">
					<div>
						<h2 class="hris-modal-title">Career Update</h2>
						<p class="hris-modal-subtitle">{{ fullname }}</p>
					</div>
					<q-btn flat dense round v-close-popup class="hris-q-ghost" aria-label="Close">
						<i class="fas fa-times"></i>
					</q-btn>
				</div>
				<div class="hris-modal-body">
					<div class="hris-toolbar" style="margin-bottom: 20px;">
						<q-btn unelevated class="hris-q-outline" icon="fas fa-download" label="Download Template" @click="downloadTemplate('uploads/template/career_update.csv')"></q-btn>
						<q-btn unelevated class="hris-q-primary" icon="fas fa-upload" label="Upload CSV" @click="prompt = true"></q-btn>
					</div>
					<div class="row q-col-gutter-md">
						<div class="col-12 col-md-4">
							<div class="hris-form-section" style="margin-bottom: 0;">
								<div class="hris-form-section-title">Record Update</div>
								<q-form ref="vForm" @submit="onSubmit" class="q-gutter-md">
									<q-select outlined dense color="green" v-model="actionTake" option-value="id" option-label="name" :options="actionTakeOptions" label="Action" emit-value map-options @input="checkInput" required></q-select>
									<q-input outlined dense color="green" v-model="others" label="Action Taken" v-show="isOther"></q-input>

									<q-input outlined dense color="green" v-model="effectivity" mask="date" :rules="['date']" label="Effectivity" v-show="isCommon">
										<template v-slot:append>
											<i class="far fa-calendar-alt cursor-pointer">
												<q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
													<q-date v-model="effectivity" @input="() => $refs.qDateProxy.hide()"></q-date>
												</q-popup-proxy>
											</i>
										</template>
									</q-input>
									<q-select outlined dense color="green" v-model="cut_off" :options="cutoffoptions" label="Cut-Off" v-show="isCommon"></q-select>

									<q-input outlined dense color="green" v-model="from" label="From" v-show="isFromTo"></q-input>

									<q-select outlined dense color="green" v-model="location" :options="locationOptions" label="TO" v-show="isTransfer" @input="selectedItem"></q-select>
									<q-select outlined dense color="green" v-model="rank" :options="rankOptions" label="TO" v-show="isPromotion" @input="selectedItem"></q-select>
									<q-select outlined dense color="green" v-model="employmentStatus" :options="employmentStatusOption" label="TO" v-show="isChange" @input="selectedItem"></q-select>

									<q-input outlined dense color="green" v-model="basicsalary" label="Basic Salary" type="number" v-show="isSsalary" @input="changeSalary"></q-input>
									<q-input outlined dense color="green" v-model="allowance" label="Allowance" type="number" v-show="isSsalary" @input="changeAllowance"></q-input>
									<q-input outlined dense color="green" v-model="deminimis" label="Deminimis" type="number" v-show="isSsalary"></q-input>

									<q-input outlined dense color="green" v-model="remarks" label="Remarks" v-show="isCommon"></q-input>

									<div class="hris-form-actions" style="justify-content: flex-start; padding: 4px 0 0;">
										<q-btn unelevated color="negative" label="Delete" @click="deleteCareer()" v-show="isSelected"></q-btn>
										<q-btn unelevated class="hris-q-primary" label="Submit" type="submit"></q-btn>
										<q-btn unelevated class="hris-q-outline" label="Close" @click="closeModal"></q-btn>
									</div>
								</q-form>
							</div>
						</div>
						<div class="col-12 col-md-8">
							<div class="hris-panel" style="margin-bottom: 0;">
								<div class="hris-panel-title">Career Update History</div>
								<q-table flat :data="careerupdates" :columns="columns" row-key="id" :pagination.sync="pagination">
									<template v-slot:body="props">
										<q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
											<q-td key="action_taken" :props="props">{{ props.row.action_taken }}</q-td>
											<q-td key="effectivity" :props="props">{{ props.row.effectivity }}</q-td>
											<q-td key="cut_off" :props="props">{{ props.row.cut_off }}</q-td>
											<q-td key="from" :props="props">{{ props.row.from }}</q-td>
											<q-td key="to" :props="props">{{ props.row.to }}</q-td>
											<q-td key="basic_salary" :props="props">{{ props.row.basic_salary }}</q-td>
											<q-td key="allowance" :props="props">{{ props.row.allowance }}</q-td>
											<q-td key="deminimis" :props="props">{{ props.row.deminimis }}</q-td>
											<q-td key="total" :props="props">{{ props.row.total }}</q-td>
											<q-td key="remarks" :props="props">{{ props.row.remarks }}</q-td>
											<q-td key="update_by" :props="props">{{ props.row.update_by }}</q-td>
											<q-td key="date_created" :props="props">{{ props.row.date_created }}</q-td>
										</q-tr>
									</template>
									<template v-slot:no-data="">
										<div class="hris-empty full-width">No career update records found.</div>
									</template>
								</q-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</q-dialog>
		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius);">
				<q-spinner color="green" size="40px"></q-spinner>
				<span>Saving…</span>
			</div>
		</q-dialog>

		<q-dialog v-model="prompt" persistent>
			<div class="hris-modal" style="max-width: 420px;">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">Upload CSV File</h2>
				</div>
				<div class="hris-modal-body">
					<q-file outlined dense color="green" v-model="fileUpload" label="Select CSV File" accept=".csv"></q-file>
				</div>
				<div class="hris-modal-footer">
					<q-btn unelevated class="hris-q-outline" label="Cancel" v-close-popup></q-btn>
					<q-btn unelevated class="hris-q-primary" label="Upload" @click="onUpload"></q-btn>
				</div>
			</div>
		</q-dialog>
	</div>
	</template>
	<script>
	import axios from 'axios';
	import mixins from '../../mixins';

	export default {

		data() {
			return {
				obj:{},
				tempID:0,
				isSelected:false,
				titleCareer:'Career Update',

				isCommon:false,
				isSsalary:false,
				isOther:false,
				isFromTo:false,

				pagination: {
		        	rowsPerPage: 10
		      	},
				cut_off:null,
				career:false,
				spinner:false,
				fullname:null,
				emp_id:null,
				actionTake:null,
				others:null,
				basicsalary:0,
				allowance:0,
				deminimis:0,
				total:0,
				effectivity:null,
				from:'',
				to:'',
				location:'',
				locationOptions:'',
				rank:'',
				rankOptions:'',
				employmentStatus:'',
				employmentStatusOption:'',
				isPromotion:false,
				isTransfer:false,
				isChange:false,
				isSsalaryAdjust:false,
				remarks:'',
				actionTaken:null,
				columns: [
			//	{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
				{ name: 'action_taken', align: 'center', label: 'Action Taken', field: 'action_taken', sortable: true },
				{ name: 'effectivity', label: 'Effectivity', field: 'effectivity', sortable: true },
				{ name: 'cut_off', label: 'Cut-off', field: 'cut_off', sortable: true },
				{ name: 'from', label: 'From', field: 'from' , sortable: true},
				{ name: 'to', label: 'To', field: 'to' , sortable: true},
				{ name: 'basic_salary', label: 'Basic Salary', field: 'basic_salary' , sortable: true},
				{ name: 'allowance', label: 'Allowance', field: 'allowance' , sortable: true},
				{ name: 'deminimis', label: 'Deminimis', field: 'deminimis' , sortable: true},
				{ name: 'total', label: 'Total', field: 'total' , sortable: true},
				{ name: 'remarks', label: 'Remarks', field: 'remarks' , sortable: true},
				{ name: 'update_by', label: 'Update by', field: 'update_by' , sortable: true},
				{ name: 'date_created', label: 'Date Updated', field: 'date_created' , sortable: true},
				],
				cutoffoptions: ['26 - 10', '11 - 25'],
				careerupdates: [],
				actionTakeOptions:[],
				//ruben::26/07/2023
				prompt: false,
				fileUpload: '',
			}
		},
		created(){
			this.eventHub.$on('CareerUpdates', this.careerUpdate);
			this.getDropdownProperties()

		},

		methods: {
			// ===================================================================================
			// ruben::26/07/2023

			msgAlrt(title,caption,type){
				let color = (type == 'success') ? 'positive' : 'negative'
				let icon = (type == 'success') ? 'far fa-check-circle' : 'far fa-times-circle'
				this.$q.notify({
					icon:icon,
					message:title,
					caption:caption,
					color:color
				})
			},
			onUpload(){
				let formData  = new FormData();
				formData.append("files", this.fileUpload);
				axios({
					headers : {'Authorization' : `Bearer ${this.token}`},
					url:this.apiUrl+'/employee/career-update',
					data: formData,
					method: 'POST'
				}).then(response => {
					this.msgAlrt('Success','File Uploaded successfully','success')
					this.prompt = false
					this.fileUpload = ''
					// this.loadData()
					console.log('career update: upload',response.data)
				})
			},

			downloadTemplate: function(url) {
				axios({
					url: this.apiUrl + '/' + url,
					method: 'GET',
					responseType: 'arraybuffer',
				}).then((response) => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					var fileLink = document.createElement('a');
					fileLink.href = fileURL;
					fileLink.setAttribute('download', 'CareerUpdateTemplate.csv');
					document.body.appendChild(fileLink);

					fileLink.click();
				});
			},
			// end function
			// ===================================================================================
			
			checkInput:function(){

				this.isSelected = false
				this.to = ''
				this.location =''
				this.rank =''
				this.employmentStatus=''

				var selected = this.actionTake;
				//console.log(selected)

				if(selected == 2){//Transfer
		          	this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = false
		          	this.isOther = false

					this.isTransfer = true
					this.isChange = false
					this.isPromotion = false
					this.from = this.obj.location
		        }else  if(selected == 3){ //Transfer with Salary Adjustment
		          	this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = true
		          	this.isOther = false

					this.isTransfer = true
					this.isChange = false
					this.isPromotion = false
					this.from = this.obj.location
		        }else  if(selected == 4){ //Salary Adjustment
		          	this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = true
		          	this.isOther = false

					this.isTransfer = false
					this.isChange = false
					this.isPromotion = false
					this.from = this.obj.basic_salary
				}else  if(selected == 5){ //Change Employment Status
					this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = false
		          	this.isOther = false

					this.isTransfer = false
					this.isChange = true
					this.isPromotion = false
					this.from = this.obj.employment_status

				}else  if(selected == 6){ //Change Employment Status with Salary Adjustment

					this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = true

					this.isTransfer = false
					this.isChange = true
					this.isPromotion = false
					this.from = this.obj.employment_status
				}else  if(selected == 9){ //Temporary allowance
					this.isCommon = true
					this.isFromTo = true
					this.isSsalary = true

					this.isTransfer = false
					this.isChange = false
					this.isPromotion = false
					this.from = this.obj.allowance
				}else  if(selected == 10){ //Promotion
					this.isCommon = true
		          	this.isFromTo = true
		          	this.isSsalary = true

					this.isTransfer = false
					this.isChange = false
					this.isPromotion = true
					this.from = this.obj.rank
		        }else{
		          	this.isCommon = false
		          	this.isSsalary = false
		          	this.isOther = false
		          	this.isFromTo = false

					this.isTransfer = false
					this.isChange = false
					this.isPromotion = false
		        }

      },
	  		changeSalary:function(val){
				var selected = this.actionTake;
				if(selected == 4){
					this.to = this.basicsalary
				}
			},
			changeAllowance:function(val){
				var selected = this.actionTake;
				if(selected == 9){
					this.to = this.allowance
				}
			},
			selectedItem:function(val){
				this.to = val
			},

			selectedRow:function(obj){
				var id = this.actionTakeOptions.filter(x => x.name.toLowerCase() === obj.row.action_taken.toLowerCase());
				this.actionTake = id[0].id
				this.tempID = obj.row.id
				this.from = obj.row.from

				this.checkInput()
				this.isSelected = true
			},

		//delete selected career updates
		deleteCareer:function(){
			axios({
				headers : {'Authorization' : `Bearer ${this.token}`},
				url:this.apiUrl+`/employee/delete/careerupdate/${this.tempID}`,
				method: 'POST'
			}).then(response => {
				this.getCareerUpdate(this.emp_id)
			}).catch((error) => {
				console.log(error.response)
			})
		},

		getDropdownProperties:function(){

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).get('/employee/dropdown/properties')
			.then((res) => {
				this.locationOptions = res.data.data.location
				this.rankOptions = res.data.data.rank
				this.employmentStatusOption = res.data.data.empStatus
			});
		},


		//list of career update for selected employee
    careerUpdate:function(payload){
		this.actionTake = ''
		this.isCommon = false
		this.isSsalary = false
		this.isOther = false
		this.isFromTo = false
		this.isTransfer = false

		this.obj = payload.employee.row

      	this.from = payload.employee.row.employment_status
      	this.basicsalary = payload.employee.row.basic_salary
      	this.allowance = payload.employee.row.allowance
      	this.deminimis = payload.employee.row.deminimis
		this.location = payload.employee.row.location


         // console.log(payload.employee.row.employment_status)

          var total =  parseInt(this.basicSalary) + parseInt(this.allowance) + parseInt(this.deminimis);
          this.total = total;

          this.fullname = payload.employee.row.firstname + ' ' + payload.employee.row.lastname + '' + ' Career Update'
          this.emp_id = payload.employee.key
          this.career = payload.stat
          this.getCareerUpdate(payload.employee.key)
      },

      onSubmit:function(){
      	if(this.actionTake == 8){
      		this.actionTaken = this.others
      	}else{
      		this.actionTaken = this.actionTakeOptions[this.actionTake - 1].name
      	}

      	this.spinner = true
      	let formData  = new FormData();
      	formData.append("emp_id", this.emp_id);
      	formData.append("action_taken",this.actionTaken);
      	formData.append("effectivity", this.effectivity);
      	formData.append("cut_off", this.cut_off);
      	formData.append("from", this.from);
      	formData.append("to", this.to);
      	formData.append("basicsalary", this.basicsalary);
      	formData.append("allowance", this.allowance);
      	formData.append("deminimis", this.deminimis);
      	formData.append("remarks", this.remarks);
      	formData.append("updateby", this.usersFullname);
      	axios({
      		headers : {'Authorization' : `Bearer ${this.token}`},
      		url:this.apiUrl+'/employee/update/career',
      		data: formData,
      		method: 'POST'
      	})
      	.then(response => {


      		setTimeout(() => {
      			this.spinner = false
      		},500)
      		this.getCareerUpdate(this.emp_id)
      	}).catch((error) => {
      		console.log(error.response)
      	})
      },

      getCareerUpdate:function(id){
      	axios.create({
      		baseURL: this.apiUrl,
      		headers: {
      			'Authorization': `Bearer ${this.token}`
      		}})
      	.get(`/employee/career/list/${id}`)
      	.then((res) => {
      		this.careerupdates = res.data.data;
			console.log(this.careerupdates)
      		this.actionTakeOptions = res.data.actiontake;

      	})

      },

      closeModal:function(){
      	this.career = false
      },
  }
}
</script>
<style lang="css" scoped>
</style>
